<template>
    <div>
        <div class="wrapper" :class="{ 'padding-y': additionalPaddingY }">
            <div class="image-wrapper">
                <component :is="blok.Image[0].component" v-if="blok.Image[0].image.filename" :blok="blok.Image[0]" />
            </div>
            <NuxtLink :to="getL4InternalLink(blok.mainLink)" class="main-link" external></NuxtLink>
            <h2 v-if="blok.Title">{{ blok.Title }}</h2>
            <div v-if="blok.Links.length" class="links-wrapper">
                <NuxtLink
                    v-for="link in blok.Links"
                    :key="link._uid"
                    :to="getL4InternalLink(link.Link)"
                    class="link"
                    external
                >
                    {{ link.Text }}
                </NuxtLink>
            </div>
            <p v-if="blok.subTitle">
                {{ blok.subTitle }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4HelpTile } from '~/types/components/L4HelpTile';

const { blok } = defineProps<{ blok: IL4HelpTile }>();

const additionalPaddingY = computed(() => !blok.Links.length && blok.subTitle);
</script>

<style lang="postcss" scoped>
.wrapper {
    @apply relative h-full border-spacing-4 border bg-[#f2f2f2] flex flex-col justify-center relative pl-28 pr-3 py-6 border-separate border-solid border-[#dfdfdf];

    .main-link {
        @apply block w-full h-full absolute top-0 left-0;
    }

    &.padding-y {
        @apply md:py-12 py-4 min-h-[188px];
    }

    p {
        @apply text-[#323232] text-base mt-2;
    }

    &:hover {
        @apply bg-[white];
    }

    .links-wrapper {
        @apply relative flex flex-col;

        a:first-of-type {
            @apply pt-4;
        }

        a:not(:last-of-type) {
            @apply pb-2;
        }

        a {
            @apply text-left cursor-pointer font-semibold text-base text-primary leading-[17px];

            &:hover {
                @apply text-[#9970ab];
            }
        }
    }

    a {
        @apply text-left;
    }

    h2 {
        @apply cursor-pointer font-semibold text-2xl leading-none text-black m-0;
    }

    .image-wrapper {
        @apply content-[''] absolute w-[81px] h-[82px] -translate-y-2/4 left-4 top-2/4;
    }
}
</style>
